import { createAction } from '@reduxjs/toolkit'

export const MENU_ACTION = 'MENU'
export const SET_MENU_EXPANDED_ACTION = `${MENU_ACTION}/SET_EXPANDED`
export const SET_MENU_COLLAPSED_ACTION = `${MENU_ACTION}/SET_COLLAPSED`

export const setMenuExpandedAction = createAction<boolean>(SET_MENU_EXPANDED_ACTION)
export const setMenuCollapsedAction = createAction<string>(SET_MENU_COLLAPSED_ACTION)
